export var URL_QUERY_PARAM_INTERACTION_SESSION = 'xpis';
export var generateUrlWithParams = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
  var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
  var interactionSession = {
    bridge: bridge,
    id: interactionSessionId,
    source: interactionSource
  };
  var paramValueEncoded = btoa(JSON.stringify(interactionSession));
  var urlObj = new URL(url);
  urlObj.searchParams.set(URL_QUERY_PARAM_INTERACTION_SESSION, paramValueEncoded);
  return urlObj.toString();
};